import React, { Fragment, useEffect, useRef, useState } from "react";
import { TiArrowUp } from "react-icons/ti";
import audioBell from "../../audio/notification-bell.wav";
import CustomHelmet from "../reusable/Helmet";
import "../../styles/psychology.scss";
import moment from "moment";
import Footer from "../reusable/Footer";
import userService from "../../services/userService";
import blackBgImg from "../../images/blackBg.png";
import PIQModal from "../reusable/PIQModal";
import GptHeader from "../gptHeader";

const sdtArray = [
  {
    id: 1,
    sdt: "What do your parents think about you?",
  },
  {
    id: 2,
    sdt: "What do your teachers or seniors (if you are working) think about you?",
  },
  {
    id: 3,
    sdt: "What do your friends or colleagues (if you are working) think about you?",
  },
  {
    id: 4,
    sdt: "How do you perceive yourself?",
  },
  {
    id: 5,
    sdt: "What kind of person do you aspire to become in life?",
  },
];
const notification = new Audio(audioBell);
const PsychologyTest = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [showPIQModal, setShowPIQModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  let [tatImages, setTatImageList] = useState([]);
  let [wordArray, setWordArray] = useState([]);
  let [srtArray, setSrtArray] = useState([]);

  // HANDLE TAT IMAGE TEST STATE  STARTS
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [tatTimer, setTatTimer] = useState(30);
  const [typingTimer, setTypingTimer] = useState(240);
  const [showImage, setShowImage] = useState(true);
  const [showTypingText, setShowTypingText] = useState(false);

  const handleTatStart = async () => {
    setIsLoading(true);
    const query = "TAT";
    try {
      const apiResponseData = await userService.generateTatImage(query);
      if (apiResponseData) {
        const apiImage = apiResponseData?.data?.image;
        setTatImageList([
          ...apiImage,
          { _id: "dummy_blank_img", image: blackBgImg },
        ]);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const generateWatWords = async () => {
    try {
      const apiResponseData = await userService.generateWatWords();
      if (apiResponseData) {
        const apiWords = apiResponseData?.data?.words;
        setWordArray(apiWords);
      }
    } catch (error) {
      console.log("Words not found for WAT");
    }
  };
  const generateSRT = async () => {
    try {
      const apiResponseData = await userService.generateSRT();
      if (apiResponseData) {
        const apiSrt = apiResponseData?.data?.situations;
        setSrtArray(apiSrt);
      }
    } catch (error) {
      console.log("Words not found for WAT");
    }
  };

  useEffect(() => {
    if (activeStep === 1) {
      handleTatStart(); // GENERATE IMAGES ON INTIAL LOAD
      generateWatWords(); // GENERATE WAT ON INTIAL LOAD
      generateSRT(); // GENERATE SRT ON INTIAL LOAD
    }
  }, [activeStep]);

  useEffect(() => {
    let timer;
    if (
      activeStep === 1 &&
      tatImages?.length > 0 &&
      currentImageIndex < tatImages.length
    ) {
      if (showImage) {
        if (tatTimer > 0) {
          timer = setTimeout(() => setTatTimer(tatTimer - 1), 1000);
        } else {
          notification.play();
          setShowImage(false);
          setShowTypingText(true);
          setTypingTimer(240);
        }
      } else if (showTypingText) {
        if (typingTimer > 0) {
          timer = setTimeout(() => setTypingTimer(typingTimer - 1), 1000);
        } else {
          if (currentImageIndex < tatImages.length - 1) {
            notification.play();
            setShowImage(true);
            setShowTypingText(false);
            setTatTimer(30);
            setCurrentImageIndex(currentImageIndex + 1);
          } else {
            setActiveStep(2);
            notification.play();
          }
        }
      }
    }

    return () => clearTimeout(timer);
  }, [
    activeStep,
    currentImageIndex,
    tatTimer,
    typingTimer,
    showImage,
    showTypingText,
    tatImages.length,
  ]);
  // HANDLE TAT IMAGE TEST STATE  ENDS

  // HANDLE WAT  TEST STARTS
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [watTimer, setWatTimer] = useState(15);

  const handleWatStart = async () => {
    setActiveStep(activeStep + 1);
  };

  useEffect(() => {
    let timer;

    if (
      activeStep === 3 &&
      wordArray?.length > 0 &&
      currentWordIndex < wordArray.length
    ) {
      if (watTimer > 0) {
        timer = setTimeout(() => setWatTimer(watTimer - 1), 1000);
      } else {
        if (currentWordIndex < wordArray.length - 1) {
          setWatTimer(15);
          notification.play();
          setCurrentWordIndex(currentWordIndex + 1);
        } else {
          setActiveStep(activeStep + 1);
          notification.play();
        }
      }
    }

    return () => clearTimeout(timer);
  }, [activeStep, currentWordIndex, watTimer, wordArray.length]);
  // HANDLE WAT TEST ENDS

  // HANDLE SRT TEST STARTS
  const [srtTimer, setSrtTimer] = useState(1800);

  const handleSrtStart = async () => {
    setActiveStep(activeStep + 1);
  };

  useEffect(() => {
    let timer;
    if (activeStep === 5 && srtArray?.length > 0) {
      if (srtTimer > 0) {
        timer = setTimeout(() => setSrtTimer(srtTimer - 1), 1000);
      } else {
        setActiveStep(activeStep + 1);
        notification.play();
      }
    }

    return () => clearTimeout(timer);
  }, [activeStep, srtTimer, srtArray?.length]);
  // HANDLE SRT TEST ENDS

  // HANDLE SDT TEST STARTS
  const [sdtTimer, setSdtTimer] = useState(900);

  const handleSdtStart = async () => {
    setActiveStep(activeStep + 1);
  };

  useEffect(() => {
    let timer;
    if (activeStep === 7 && sdtArray?.length > 0) {
      if (sdtTimer > 0) {
        timer = setTimeout(() => setSdtTimer(sdtTimer - 1), 1000);
      } else {
        setActiveStep(activeStep + 1);
        notification.play();
      }
    }

    return () => clearTimeout(timer);
  }, [activeStep, sdtTimer]);
  // HANDLE SDT TEST ENDS

  // SCROLL HER PAGE AFTER EVERY SEARCH STARTS
  const scrollRef = useRef(null);

  const formatTime = (timeInSeconds) => {
    const minutes = moment.duration(timeInSeconds, "seconds").minutes();
    const seconds = moment.duration(timeInSeconds, "seconds").seconds();
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleSubmitSrt = () => {};

  // Reload page prompt start
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      // Modern browsers ignore returnValue, but it's good to set it for older browsers
      event.returnValue = "";
      return "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  // Reload page prompt ends

  // GET MY PIQ STARTS
  const [myPIQ, setMyPIQ] = useState({});
  const [PIQLoading, setPIQLoading] = useState(false);
  async function fetchPIQ() {
    setPIQLoading(true);
    try {
      const result = await userService.myPIQ();
      if (result?.data?.piq) {
        setMyPIQ(result.data.piq);
        setPIQLoading(false);
      } else {
        console.warn("No PIQ data found in response.");
        setPIQLoading(false);
      }
    } catch (error) {
      console.error("Error fetching PIQ:", error);
    } finally {
      setPIQLoading(false);
    }
  }

  useEffect(() => {
    fetchPIQ();
  }, []);
  // GET MY PIQ ENDS


  // HANDLE SEND/UPDATE RESPONSE START
  const initialTATState = Array.from({ length: 12 }, (_, i) => ({
    question: `TAT ${i + 1}`,
    answer: "",
  }));

  const [answers, setAnswers] = useState(initialTATState);

  console.log('====================================');
  console.log("answers", answers);
  console.log('====================================');

  const handleInputChange = (index, value) => {
    setAnswers((prevAnswers) => {
      prevAnswers[index].answer = value;
      return [...prevAnswers];
    });
  };
  // HANDLE SEND/UPDATE RESPONSE ENDS

  return (
    <Fragment>
      <CustomHelmet
        title="SSB-GPT: Your SSB Interview Self Preparation Tool"
        description="Prepare effectively for your SSB/AFSB/NSB/ interview with SSB-GPT, a free self-preparation tool."
      />
      {/* <GptLayout> */}
      <GptHeader />
      <div className="container">
        <section className="psychologyTestMain">
          <section className="gpt_Search_box">
            <div className="input_box">
              <div
                className="srch_output custonScroll"
                style={{
                  height:
                    activeStep === 9
                      ? "calc(100vh - 240px)"
                      : "calc(100vh - 140px)",
                }}
                ref={scrollRef}
              >
                {/* TAT TEST SECTION STARTS  */}
                {activeStep === 1 && (
                  <>
                    {isLoading ? (
                      <div className="tat_test_msg">
                        <p>
                          Your Test is preparing. It will take upto 10-20
                          seconds. <br />
                          Do not refresh the page in case you may loss data
                        </p>
                      </div>
                    ) : (
                      <>
                        <div className="time_box">
                          <h1>TAT</h1>
                          <p>
                            {showImage
                              ? formatTime(tatTimer)
                              : formatTime(typingTimer)}
                          </p>
                          {/* <div
                            className="timer"
                            style={{
                              background: `conic-gradient(red ${timerProgress.current}%, #ddd ${timerProgress.current}% 100%)`,
                            }}
                          >
                            <p>{formattedTime.current}</p>
                          </div> */}
                        </div>
                        <div className="test_box">
                          {showImage && tatImages[currentImageIndex] && (
                            <>
                              <img
                                src={tatImages[currentImageIndex].image}
                                alt="ssb gpt tatimage"
                              />
                            </>
                          )}
                          {showTypingText && (
                            <div>
                              <strong>Start Writing</strong>
                            </div>
                          )}

                          {/* */}
                        </div>
                      </>
                    )}
                  </>
                )}
                {/* TAT TEST SECTION ENDS */}

                {/* WAT SECTION STARTS  */}
                {activeStep === 2 && (
                  <div className="instructions">
                    <h2>Instructions :</h2>
                    <p>
                      Your TAT is complete. Are you ready to proceed with the
                      WAT, or would you like to take a break? Once you're ready,
                      click the 'Start' button.
                    </p>

                    <div className="btn_wrap">
                      <button onClick={() => handleWatStart()}>
                        Start WAT
                      </button>
                    </div>
                  </div>
                )}
                {activeStep === 3 && (
                  <>
                    {isLoading ? (
                      <div className="tat_test_msg">
                        <p>
                          Your Test is preparing. It will take upto 10-20
                          seconds. <br />
                          Do not refresh the page in case you may loss data
                        </p>
                      </div>
                    ) : (
                      <>
                        <div className="time_box">
                          <h1>WAT</h1>
                          <p>{formatTime(watTimer)}</p>
                        </div>
                        <div className="test_box">
                          {wordArray[currentWordIndex] && (
                            <div>
                              <h4>{wordArray[currentWordIndex].word}</h4>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </>
                )}
                {/* WAT SECTIONS ENDS */}

                {/* SRT SECTION STARTS */}
                {activeStep === 4 && (
                  <div className="instructions">
                    <h2>Instructions :</h2>
                    <p>
                      Your WAT is complete! Are you ready to begin the SRT, or
                      would you like to take a break? Once you're ready, click
                      the Start button to proceed.
                    </p>

                    <div className="btn_wrap">
                      <button onClick={() => handleSrtStart()}>
                        Start SRT
                      </button>
                    </div>
                  </div>
                )}
                {activeStep === 5 && (
                  <>
                    {isLoading ? (
                      <div className="tat_test_msg">
                        <p>
                          Your Test is preparing. It will take upto 10-20
                          seconds. <br />
                          Do not refresh the page in case you may loss data
                        </p>
                      </div>
                    ) : (
                      <>
                        <div className="time_box">
                          <h1>SRT</h1>
                          <p>{formatTime(srtTimer)}</p>
                        </div>
                        <div className="test_box">
                          {srtArray?.map((ele, idx) => (
                            <p className="srt" key={idx}>
                              {idx + 1}. {ele?.situation}
                            </p>
                          ))}
                        </div>
                      </>
                    )}
                  </>
                )}
                {/* SRT SECTION STARTS */}

                {/* SDT TEST STARTS  */}
                {activeStep === 6 && (
                  <div className="instructions">
                    <h2>Instructions :</h2>
                    <p>
                      Your SRT is complete. Are you ready to begin the
                      Self-Description Test, or would you like to take a break?
                      Once you're ready, click the 'Start' button to proceed.
                    </p>
                    <div className="btn_wrap">
                      <button onClick={() => handleSdtStart()}>
                        Start SDT
                      </button>
                    </div>
                  </div>
                )}

                {activeStep === 7 && (
                  <>
                    {isLoading ? (
                      <div className="tat_test_msg">
                        <p>
                          Your Test is preparing. It will take upto 10-20
                          seconds. <br />
                          Do not refresh the page in case you may loss data
                        </p>
                      </div>
                    ) : (
                      <>
                        <div className="time_box">
                          <h1>SDT</h1>
                          <p>{formatTime(sdtTimer)}</p>
                        </div>
                        <div className="test_box">
                          {sdtArray?.map((ele, idx) => (
                            <p key={idx}>
                              {idx + 1}. {ele?.sdt}
                            </p>
                          ))}
                        </div>
                      </>
                    )}
                  </>
                )}
                {/* SDT TEST ENDS */}

                {activeStep === 8 && (
                  <div className="test_box">
                    <p>
                      Your psychology test is now complete. Before submitting
                      your responses, please ensure you have filled out your PIQ
                      Form. If you have already completed the PIQ Form, you can
                      proceed by clicking 'Start Submitting Responses'.
                    </p>
                    <div className="upload_btn">
                      <button onClick={() => setShowPIQModal(true)}>
                        Fill/Update PIQ
                      </button>
                      <button onClick={() => setActiveStep(activeStep + 1)}>
                        Start Submitting Responses
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div className="answer_input_gpt feedback_input">
                {activeStep === 9 && (
                  <div>
                    <div className="input_index custonScroll">
                      <div>
                        <span>Ans 1:</span>
                        <textarea
                          value={answers[1].answer}
                          onChange={(e) => handleInputChange(1, e.target.value)}
                          placeholder="Write your answer"
                        />
                      </div>
                    </div>
                    <button
                      className="search"
                      onClick={() => handleSubmitSrt()}
                    >
                      <TiArrowUp />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </section>
        </section>
      </div>

      {/* PIQ FORM MODAL START */}
      <PIQModal
        show={showPIQModal}
        setShow={setShowPIQModal}
        myPIQ={myPIQ}
        PIQLoading={PIQLoading}
        fetchPIQ={fetchPIQ}
      />
      {/* PIQ FORM MODAL ENDS */}

      <Footer />
    </Fragment>
  );
};

export default PsychologyTest;
